<script setup lang="ts">
import { computed } from 'vue';

import PresenterValueFallback from '@satellite/components/elements/presenters/PresenterValueFallback.vue';

import type { PresenterDisplaySize } from '@satellite/composables/presenterDisplayOptions';
import type {
  YardAreaDisplayField,
  YardAreaDisplayData
} from '@satellite/composables/useYardAreaDisplay';

const {
  data,
  size,
  displayFields = ['name']
} = defineProps<{
  data: YardAreaDisplayData;
  size?: PresenterDisplaySize;
  displayFields?: YardAreaDisplayField[];
}>();

const resolvedSize = computed(() => size ?? data.size);

const showName = computed(() => displayFields.includes('name'));
</script>

<template>
  <span
    class="d-flex yard-area-display-v2"
    v-bind="$attrs"
    :class="{
      'typography-body-sm': resolvedSize === 'small',
      'typography-body-md': resolvedSize === 'regular',
      'typography-heading-lg-bold': resolvedSize === 'large'
    }">
    <template v-if="showName">
      <slot name="area-name" :area-name="data.name" :area-name-attrs="data.nameAttrs">
        <presenter-value-fallback v-if="!data.name" data-testid="yard-area-presenter-area-name" />
        <span v-else v-bind="data.nameAttrs">
          {{ data.name }}
        </span>
      </slot>
    </template>
  </span>
</template>
